/**
 * Guards for reading the backend's answers (API_ACCESS.md §3). The client hands an answer on as `unknown`, and the
 * backend checks few types, so a reader checks a value's shape before it reads a field of it. These two checks live
 * here, in the app-wide `api` piece, so every domain that reads an answer (reservations, tables) reads it the same way
 * and none keeps its own copy.
 */

/**
 * True for a plain object (not null, not a list). A reader checks its input with it first, so an answer of the
 * wrong shape (null, text, a list where one record was expected) is read as nothing instead of throwing.
 */
export function isPlainRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** True for a string that has something in it besides spaces: an id or a name a reader can use. */
export function isFilledString(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "";
}
